/* ================================================
   ld-hero.js — Landing Hero Section scaling
================================================ */
(function () {
  'use strict';

  var DESK_W = 1440;
  var DESK_H = 927;
  var MOB_W  = 375;
  var MOB_H  = 546;

  function scaleDesk() {
    var outer = document.querySelector('.ld-hero__desk-outer');
    var frame = document.querySelector('.ld-hero__desk-frame');
    if (!outer || !frame) return;

    var vw = window.innerWidth;
    var s  = vw / DESK_W;

    frame.style.transformOrigin = 'top left';
    frame.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(DESK_H * s) + 'px';
    frame.style.visibility = 'visible';
  }

  function scaleMob() {
    var outer = document.querySelector('.ld-hero__mob-outer');
    var frame = document.querySelector('.ld-hero__mob-frame');
    if (!outer || !frame) return;

    var vw = window.innerWidth;
    var s  = vw / MOB_W;

    frame.style.width = MOB_W + 'px';
    frame.style.overflow = 'hidden';
    frame.style.transformOrigin = 'top left';
    frame.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(MOB_H * s) + 'px';
    outer.style.overflow = 'hidden';
    frame.style.visibility = 'visible';
  }

  function scaleAll() {
    scaleDesk();
    scaleMob();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleAll);
  } else {
    scaleAll();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scaleAll, 50);
  });
})();

/* ================================================
   ld-tvproof.js — Offer interactions + Slider
================================================ */
(function () {
  'use strict';

  /* ------------------------------------------------
     YouTube IFrame API loader
  ------------------------------------------------ */
  var ytReady = false;
  var ytReadyCallbacks = [];

  function loadYouTubeAPI(callback) {
    if (ytReady && window.YT && window.YT.Player) { callback(); return; }
    ytReadyCallbacks.push(callback);
    if (window._ldTvproofYtLoading) return;
    window._ldTvproofYtLoading = true;
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
    window.onYouTubeIframeAPIReady = function () {
      ytReady = true;
      ytReadyCallbacks.forEach(function (cb) { cb(); });
      ytReadyCallbacks = [];
    };
  }

  function getYoutubeId(url) {
    if (!url) return '';
    var m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([^&?/]+)/);
    return m ? m[1] : '';
  }

  /* ------------------------------------------------
     Fullscreen scroll fix — desktop only
     fullscreenchange fires BEFORE browser scroll,
     so we use double rAF to execute after it
  ------------------------------------------------ */
  var lastScrollY = 0;

  window.addEventListener('scroll', function () {
    var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    if (!fsEl) { lastScrollY = window.scrollY; }
  }, { passive: true });

  document.addEventListener('fullscreenchange', function () {
    var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    if (!fsEl && lastScrollY > 0) {
      var target = lastScrollY;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo(0, target);
        });
      });
    }
  });

  document.addEventListener('webkitfullscreenchange', function () {
    var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    if (!fsEl && lastScrollY > 0) {
      var target = lastScrollY;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo(0, target);
        });
      });
    }
  });

  /* ------------------------------------------------
     Helpers
  ------------------------------------------------ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function calcDiscount(originalCents, saleCents) {
    if (!originalCents || originalCents <= saleCents) return '';
    var pct = Math.round((originalCents - saleCents) / originalCents * 100);
    return pct > 0 ? pct + '%\nOFF' : '';
  }

  function getTotalBottles(variantTitle) {
    if (!variantTitle) return 1;
    var title = variantTitle.toLowerCase();
    var buyMatch = title.match(/buy\s+(\d+)/);
    var getMatch = title.match(/get\s+(\d+)/);
    var buy = buyMatch ? parseInt(buyMatch[1], 10) : 1;
    var get = getMatch ? parseInt(getMatch[1], 10) : 0;
    return buy + get;
  }

  /* ------------------------------------------------
     Product block
  ------------------------------------------------ */
  function initProductBlock(section) {
    var handle = section.getAttribute('data-product-handle');
    if (!handle) return;

    var form             = section.querySelector('.ld-tvproof__form');
    if (!form) return;

    var inputVariantId   = form.querySelector('.ld-variant-id');
    var inputSellingPlan = form.querySelector('.ld-selling-plan');
    var btnSub           = section.querySelector('[data-purchase="subscription"]');
    var btnSingle        = section.querySelector('[data-purchase="single"]');
    var bundleRow        = section.querySelector('.ld-tvproof__bundle-row');
    var submitBtn        = form.querySelector('[type="submit"]');

    var subPriceMain   = section.querySelector('.ld-price-sub-main');
    var subPriceTotal  = section.querySelector('.ld-price-sub-total');
    var subPriceOld    = section.querySelector('.ld-price-sub-old');
    var singPriceMain  = section.querySelector('.ld-price-single-main');
    var singPriceTotal = section.querySelector('.ld-price-single-total');
    var singPriceOld   = section.querySelector('.ld-price-single-old');

    var variantImg    = section.querySelector('.ld-variant-image');
    var discountBadge = section.querySelector('.ld-discount-badge');

    var currentVariantId = null;
    var purchaseMode     = 'single';
    var productData      = null;

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product fetch failed: ' + res.status);
        return res.json();
      })
      .then(function (product) {
        productData = product;
        buildBundleButtons(product);
       var defaultVariant = product.variants[2] || product.variants[0];
        currentVariantId = String(defaultVariant.id);
        inputVariantId.value = currentVariantId;
        var btns = bundleRow.querySelectorAll('.ld-tvproof__bundle-btn');
        btns.forEach(function (b) { b.classList.remove('is-active'); });
       if (btns[2]) btns[2].classList.add('is-active');
        else if (btns[0]) btns[0].classList.add('is-active');
        updateUI();
        if (submitBtn) submitBtn.disabled = false;
      })
      .catch(function (err) { console.error('[ld-tvproof] product load error:', err); });

    function buildBundleButtons(product) {
      if (!bundleRow) return;
      bundleRow.innerHTML = '';
      product.variants.forEach(function (variant) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ld-tvproof__bundle-btn';
        btn.setAttribute('data-variant-id', String(variant.id));
        btn.textContent = variant.title;
        btn.addEventListener('click', function () {
          bundleRow.querySelectorAll('.ld-tvproof__bundle-btn').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          currentVariantId = String(variant.id);
          updateUI();
        });
        bundleRow.appendChild(btn);
      });
    }

    function getVariant(id) {
      if (!productData) return null;
      return productData.variants.find(function (v) { return String(v.id) === String(id); }) || null;
    }

    function updateImage(variant) {
      if (!variantImg) return;
      var imgSrc = variant.featured_image
        ? variant.featured_image.src
        : (productData.featured_image ? productData.featured_image.src : '');
      if (!imgSrc) return;
      variantImg.style.opacity = '0';
      variantImg.onload = function () { variantImg.style.opacity = '1'; };
      variantImg.src = imgSrc;
      variantImg.alt = variant.name || '';
    }

    function updateDiscount(variant, alloc) {
      if (!discountBadge) return;
      var originalCents, saleCents;
      if (purchaseMode === 'subscription' && alloc) {
        originalCents = variant.compare_at_price || variant.price;
        saleCents     = alloc.per_delivery_price;
      } else {
        originalCents = variant.compare_at_price;
        saleCents     = variant.price;
      }
      var text = calcDiscount(originalCents, saleCents);
      if (text) {
        discountBadge.textContent      = text;
        discountBadge.style.display    = '';
        discountBadge.style.whiteSpace = 'pre';
      } else {
        discountBadge.style.display = 'none';
      }
    }

    function updateUI() {
      var variant = getVariant(currentVariantId);
      if (!variant) return;

      var allocations = variant.selling_plan_allocations || [];
      var alloc       = allocations[0] || null;
      var hasSub      = !!alloc;

      if (!hasSub) purchaseMode = 'single';
      if (btnSub) btnSub.style.display = hasSub ? '' : 'none';
      if (btnSub)    btnSub.classList.toggle('is-active', purchaseMode === 'subscription');
      if (btnSingle) btnSingle.classList.toggle('is-active', purchaseMode === 'single');

      if (purchaseMode === 'subscription' && alloc) {
        inputSellingPlan.value    = alloc.selling_plan_id;
        inputSellingPlan.disabled = false;
      } else {
        inputSellingPlan.value    = '';
        inputSellingPlan.disabled = true;
      }

      inputVariantId.value = String(currentVariantId);

      var totalBottles = getTotalBottles(variant.title);

      if (alloc) {
        var subPerBottle = Math.round(alloc.per_delivery_price / totalBottles);
        if (subPriceMain)  subPriceMain.textContent  = formatMoney(subPerBottle);
        if (subPriceTotal) subPriceTotal.textContent = 'Total: ' + formatMoney(alloc.price);
        if (subPriceOld)   subPriceOld.textContent   = (alloc.compare_at_price > alloc.price) ? formatMoney(alloc.compare_at_price) : '';
      }

      var singPerBottle = Math.round(variant.price / totalBottles);
      if (singPriceMain)  singPriceMain.textContent  = formatMoney(singPerBottle);
      if (singPriceTotal) singPriceTotal.textContent = 'Total: ' + formatMoney(variant.price);
      if (singPriceOld)   singPriceOld.textContent   = (variant.compare_at_price > variant.price) ? formatMoney(variant.compare_at_price) : '';

      updateImage(variant);
      updateDiscount(variant, alloc);
    }

    if (btnSub)    btnSub.addEventListener('click', function () { purchaseMode = 'subscription'; updateUI(); });
    if (btnSingle) btnSingle.addEventListener('click', function () { purchaseMode = 'single'; updateUI(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var cartNotification = document.getElementById('upCart');
if (cartNotification) cartNotification.style.display = 'none';
      if (!currentVariantId) return;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

      var item = { id: currentVariantId, quantity: 1 };
      if (purchaseMode === 'subscription' && inputSellingPlan.value) {
        item.selling_plan = parseInt(inputSellingPlan.value, 10);
      }

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      })
      .then(function (res) { if (!res.ok) throw new Error('cart/add failed'); return res.json(); })
      .then(function () {
        window.location.replace('/checkout');
      })
      .catch(function (err) {
        console.error('[ld-tvproof] cart error:', err);
        if (submitBtn) {
          submitBtn.disabled    = false;
          submitBtn.textContent = form.getAttribute('data-checkout-label') || 'CHECKOUT NOW';
        }
      });
    }, true);
  }

  /* ------------------------------------------------
     Slider — Swiper.js
  ------------------------------------------------ */
function loadSwiper(callback) {
  if (window.Swiper) { callback(); return; }
  var link = document.createElement('link');
  link.rel  = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  document.head.appendChild(link);
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  script.onload = callback;
  document.head.appendChild(script);
}

function initSlider(section, sectionIndex) {
  var slides   = Array.prototype.slice.call(section.querySelectorAll('.ld-tvproof__slide'));
  var prevBtn  = section.querySelector('.ld-tvproof__arrow--prev');
  var nextBtn  = section.querySelector('.ld-tvproof__arrow--next');
  var dotsWrap = section.querySelector('.ld-tvproof__dots');
  var track    = section.querySelector('.ld-tvproof__track');
  var viewport = section.querySelector('.ld-tvproof__viewport');

  if (!viewport || !track || !slides.length) return;

  var isMobile     = window.innerWidth < 768;
  var swiper       = null;
  var players      = [];
  var activePlayer = null;

  loadSwiper(function () {
    viewport.classList.add('swiper');
    track.classList.add('swiper-wrapper');
    slides.forEach(function (sl) { sl.classList.add('swiper-slide'); });

    swiper = new Swiper(viewport, {
      loop:          true,
      speed:         450,
      slidesPerView: 1,
      spaceBetween:  12,
      autoplay: { delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true },
      navigation: { prevEl: prevBtn, nextEl: nextBtn },
      on: { slideChange: function () {
        updateDots();
        // Pause active video on slide change
        if (activePlayer) {
          try { activePlayer.pauseVideo(); } catch(e) {}
          activePlayer = null;
        }
      }},
      breakpoints: { 768: { slidesPerView: 3, spaceBetween: 24 } }
    });

    buildDots();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (swiper && swiper.autoplay) swiper.autoplay.stop();
        players.forEach(function(p) {
          try { p.player.pauseVideo(); } catch(e) {}
        });
      } else {
        if (!activePlayer && swiper && swiper.autoplay) swiper.autoplay.start();
      }
    });

    if (isMobile) {
      createMobilePlayers();
    } else {
      loadYouTubeAPI(createDesktopPlayers);
    }
  });

  function buildDots() {
    if (!dotsWrap || !swiper) return;
    dotsWrap.innerHTML = '';
    for (var i = 0; i < slides.length; i++) {
      (function (idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ld-tvproof__dot' + (idx === 0 ? ' is-active' : '');
        dot.addEventListener('click', function () { if (swiper) swiper.slideToLoop(idx); });
        dotsWrap.appendChild(dot);
      }(i));
    }
  }

  function updateDots() {
    if (!dotsWrap || !swiper) return;
    var realIdx = swiper.realIndex;
    dotsWrap.querySelectorAll('.ld-tvproof__dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === realIdx);
    });
  }

  // Mobile — plain iframe, no facade
function createMobilePlayers() {
  slides.forEach(function (slide) {
    var holder = slide.querySelector('.ld-tvproof__player');
    var ytId   = holder ? getYoutubeId(holder.getAttribute('data-video')) : '';
    if (!holder || !ytId) return;

    var iframe = document.createElement('iframe');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
    iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';
    iframe.src = 'https://www.youtube.com/embed/' + ytId +
      '?playsinline=1&rel=0&modestbranding=1';

    holder.parentNode.replaceChild(iframe, holder);
  });
}

  // Desktop — YouTube IFrame API, muted autoplay, click to unmute
  function createDesktopPlayers() {
    slides.forEach(function (slide, i) {
      var holder = slide.querySelector('.ld-tvproof__player');
      var ytId   = holder ? getYoutubeId(holder.getAttribute('data-video')) : '';
      if (!holder || !ytId) return;

      var pid = 'ld-yt-' + sectionIndex + '-' + i;
      holder.id = pid;

      // Thumbnail as background while video loads
      var thumbWrap = holder.parentNode;
      thumbWrap.style.backgroundImage = 'url(https://i.ytimg.com/vi/' + ytId + '/hqdefault.jpg)';
      thumbWrap.style.backgroundSize = 'cover';
      thumbWrap.style.backgroundPosition = 'center';

      var entry = { slide: slide, player: null, muted: true };

      var player = new YT.Player(pid, {
        videoId:    ytId,
        playerVars: { playsinline: 1, rel: 0, modestbranding: 1, mute: 1 },
        events: {
          onReady: function (evt) {
            try {
              evt.target.mute();
              evt.target.playVideo();
            } catch (e) {}
          },
          onStateChange: function (evt) {
            if (evt.data === YT.PlayerState.PLAYING && !entry.muted) {
              activePlayer = evt.target;
              slide.classList.add('is-playing');
              if (swiper && swiper.autoplay) swiper.autoplay.stop();
              // Pause all other players
              players.forEach(function (p) {
                if (p.player !== evt.target) {
                  try { p.player.pauseVideo(); p.player.mute(); } catch(e) {}
                  p.slide.classList.remove('is-playing');
                  p.muted = true;
                }
              });
            }
            if (evt.data === YT.PlayerState.PAUSED && !entry.muted && activePlayer === evt.target) {
              activePlayer = null;
              slide.classList.remove('is-playing');
              if (swiper && swiper.autoplay) swiper.autoplay.start();
            }
            if (evt.data === YT.PlayerState.ENDED) {
              entry.muted = true;
              activePlayer = null;
              slide.classList.remove('is-playing');
              try { evt.target.mute(); evt.target.seekTo(0); evt.target.playVideo(); } catch(e) {}
              if (swiper && swiper.autoplay) swiper.autoplay.start();
            }
          }
        }
      });

      entry.player = player;
      players.push(entry);

      // Click to unmute
      thumbWrap.style.cursor = 'pointer';
      thumbWrap.addEventListener('click', function () {
        if (!entry.player) return;
        entry.muted = false;
        try {
          entry.player.unMute();
          entry.player.playVideo();
        } catch(e) {}
        if (swiper && swiper.autoplay) swiper.autoplay.stop();
      });
    });
  }
}

/* ------------------------------------------------
   Bootstrap
------------------------------------------------ */
function bootstrap() {
  document.querySelectorAll('.ld-tvproof').forEach(function (section, i) {
    initProductBlock(section);
    initSlider(section, i);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}

}());


/* ================================================
   ld-aging-cycle.js — scaling for mobile + desktop
================================================ */
(function () {
  'use strict';

  function scaleBlock(outerID, innerID, canvasW) {
    var outer = document.getElementById(outerID);
    var inner = document.getElementById(innerID);
    if (!outer || !inner) return;

    inner.style.transform = 'none';
    outer.style.height = 'auto';

    var h = inner.offsetHeight;
    var s = window.innerWidth / canvasW;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  function run() {
    scaleBlock('ldag-desk-outer', 'ldag-desk', 1440);
    scaleBlock('ldag-mob-outer',  'ldag-mob',  375);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(run, 50);
  });

})();


/* ================================================
   ld-collagen.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  function scaleDesk() {
    var outer = document.getElementById('ldcol-desk-outer');
    var inner = document.getElementById('ldcol-desk');
    if (!outer || !inner) return;

    inner.style.transform = 'none';
    outer.style.height = 'auto';

    var h = inner.offsetHeight;
    var s = window.innerWidth / 1440;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-hazards.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  function scaleDesk() {
    var outer = document.getElementById('ldhaz-desk-outer');
    var inner = document.getElementById('ldhaz-desk');
    if (!outer || !inner) return;

    inner.style.transform = 'none';
    outer.style.height = 'auto';

    var h = inner.offsetHeight;
    var s = window.innerWidth / 1440;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-shield.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  function scaleDesk() {
    var outer = document.getElementById('ldsh-desk-outer');
    var inner = document.getElementById('ldsh-desk');
    if (!outer || !inner) return;

    inner.style.transform = 'none';
    outer.style.height = 'auto';

    var h = inner.offsetHeight;
    var s = window.innerWidth / 1440;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-steps.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  function scaleDesk() {
    var outer = document.getElementById('ldst-desk-outer');
    var inner = document.getElementById('ldst-desk');
    if (!outer || !inner) return;

    inner.style.transform = 'none';
    outer.style.height = 'auto';

    var h = inner.offsetHeight;
    var s = window.innerWidth / 1440;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-supply.js — desktop scaling + bundle sync
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;

  function scaleDesk() {
    var outer = document.getElementById('ldsp-desk-outer');
    var inner = document.getElementById('ldsp-desk');
    if (!outer || !inner) return;
    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';
    var h = inner.offsetHeight;
    var s = window.innerWidth / CANVAS;
    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

  var supplyCards = document.querySelectorAll(
    '#ldsp-desk .ldsp-d-card, #ldsp-mob .ldsp-m-card'
  );

  function getActiveOptionType() {
    var active = document.querySelector('.ld-tvproof__purchase-option.is-active');
    if (!active) active = document.querySelector('.ld-tvproof__purchase-option');
    if (!active) return 'sub';
    // option 0 = Subscribe & Save, option 1 = One-time
    var options = document.querySelectorAll('.ld-tvproof__purchase-option');
    var idx = Array.from(options).indexOf(active);
    return idx === 0 ? 'sub' : 'once';
  }

  function updatePerBottle() {
    var type = getActiveOptionType();
    document.querySelectorAll('.ldsp-per-bottle').forEach(function(el) {
      var price = type === 'sub' ? el.dataset.priceSub : el.dataset.priceOnce;
      if (price) el.textContent = price + ' / Bottle';
    });
  }

  // Show prices immediately on load
  updatePerBottle();

  // Supply card button clicks
  supplyCards.forEach(function(card, idx) {
    var btn = card.querySelector(
      '.ldsp-d-btn--outline, .ldsp-d-btn--filled, .ldsp-m-btn--outline, .ldsp-m-btn--filled'
    );
    if (!btn) return;

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var bundleIdx = idx % 3;

      supplyCards.forEach(function(c) {
        var b = c.querySelector('.ldsp-d-btn--outline, .ldsp-d-btn--filled, .ldsp-m-btn--outline, .ldsp-m-btn--filled');
        if (b) b.classList.remove('ldsp-btn--selected');
      });
      btn.classList.add('ldsp-btn--selected');

      var bundleBtns = document.querySelectorAll('.ld-tvproof__bundle-btn');
      bundleBtns.forEach(function(b) { b.classList.remove('is-active'); });
      if (bundleBtns[bundleIdx]) {
        bundleBtns[bundleIdx].classList.add('is-active');
        bundleBtns[bundleIdx].dispatchEvent(new MouseEvent('click', { bubbles: true }));
      }

      updatePerBottle();
    });
  });

  // Update per-bottle price when purchase option changes
  document.addEventListener('click', function(e) {
    if (e.target.closest('.ld-tvproof__purchase-option')) {
      setTimeout(updatePerBottle, 100);
    }
  });

})();


/* ================================================
   ld-compare.js — desktop scaling + video modal
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;
  var resizeTimer;

  /* ─── Desktop scale ─────────────────────────────── */
  function scaleDesk() {
    var outer = document.getElementById('ldrev-desk-outer');
    var inner = document.getElementById('ldrev-desk');
    if (!outer || !inner || window.innerWidth < 768) return;

    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';

    var h = inner.offsetHeight;
    var s = window.innerWidth / CANVAS;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  /* ─── Lazy-load poster images ───────────────────── */
  function initPosterPreload(scope) {
    if (!scope) return;

    // Poster images now have real src set in Liquid — nothing to lazy-load via JS.
    // This function is kept as a no-op for backwards compatibility
    // in case old markup (data-src only) is still present somewhere.
    var images = scope.querySelectorAll('.ldrev-preload[data-src]:not([data-loaded])');
    if (!images.length) return;

    var loadImage = function (img) {
      if (!img || img.dataset.loaded === 'true') return;
      var src = img.getAttribute('data-src');
      if (!src) return;
      img.src = src;
      img.dataset.loaded = 'true';
    };

    if (!('IntersectionObserver' in window)) {
      images.forEach(loadImage);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadImage(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '200px 0px', // reduced from 700px — load only when close
      threshold: 0.01
    });

    images.forEach(function (img) { observer.observe(img); });
  }

  /* ─── Modal ─────────────────────────────────────── */
  var modal       = null;
  var modalVideo  = null;
  var modalCaption = null;
  var lastFocused = null;

  function openModal(videoSrc, posterSrc, captionText) {
    if (!modal || !modalVideo || !videoSrc) return;

    // Remember where focus was so we can return to it on close
    lastFocused = document.activeElement;

    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();

    modalVideo.src = videoSrc;

    if (posterSrc) {
      modalVideo.setAttribute('poster', posterSrc);
    } else {
      modalVideo.removeAttribute('poster');
    }

    modalCaption.textContent = captionText || '';
    modal.classList.add('ldrev-is-open');
    modal.setAttribute('aria-hidden', 'false');

    // Lock body scroll without jumping to top
    var scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.dataset.scrollY = scrollY;

    // Focus the dialog (not the video) to avoid scroll-to-element behaviour
    var dialog = modal.querySelector('.ldrev-modal__dialog');
    if (dialog) {
      dialog.setAttribute('tabindex', '-1');
      dialog.focus({ preventScroll: true });
    }

    var playPromise = modalVideo.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.catch(function () {});
    }
  }

  function closeModal() {
    if (!modal || !modalVideo) return;

    modal.classList.remove('ldrev-is-open');
    modal.setAttribute('aria-hidden', 'true');

    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();

    // Restore scroll position — set scrollY BEFORE removing position:fixed
    // to prevent the browser visually jumping from top to saved position
    var scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.width = '';
    window.scrollTo({ top: scrollY, behavior: 'instant' });

    // Return focus to the card that was clicked
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  }

  /* ─── Bind video card clicks ─────────────────────── */
  function bindVideoCards(scope, selector) {
    if (!scope) return;

    scope.querySelectorAll(selector).forEach(function (card) {
      card.addEventListener('click', function (e) {
        // Prevent any default anchor/button behaviour that could scroll
        e.preventDefault();

        var videoSrc   = card.getAttribute('data-video-src');
        var posterSrc  = card.getAttribute('data-poster');
        var captionText = card.getAttribute('data-caption') || '';
        openModal(videoSrc, posterSrc, captionText);
      });
    });
  }

  /* ─── Load more / show less ─────────────────────── */
  function setupLoadMore(loadBtnId, hideBtnId, extraId, hiddenClass, visibleClass, isDesk) {
    var loadBtn = document.getElementById(loadBtnId);
    var hideBtn = document.getElementById(hideBtnId);
    var extra   = document.getElementById(extraId);
    if (!loadBtn || !hideBtn || !extra) return;

    loadBtn.addEventListener('click', function () {
      extra.classList.remove(hiddenClass);
      loadBtn.style.opacity = '0';
      loadBtn.style.pointerEvents = 'none';

      setTimeout(function () { loadBtn.style.display = 'none'; }, 400);

      hideBtn.classList.add(visibleClass);
      initPosterPreload(extra);

      if (isDesk) {
        bindVideoCards(extra, '.ldrev-d-video-card');
        setTimeout(scaleDesk, 650);
      } else {
        bindVideoCards(extra, '.ldrev-m-video-card');
      }
    });

    hideBtn.addEventListener('click', function () {
      extra.classList.add(hiddenClass);
      hideBtn.classList.remove(visibleClass);

      loadBtn.style.display = '';
      setTimeout(function () {
        loadBtn.style.opacity = '1';
        loadBtn.style.pointerEvents = '';
      }, 50);

      if (isDesk) setTimeout(scaleDesk, 650);
    });
  }

  /* ─── Init ───────────────────────────────────────── */
  function init() {
    modal        = document.getElementById('ldrev-modal');
    modalVideo   = document.getElementById('ldrev-modal-video');
    modalCaption = document.getElementById('ldrev-modal-caption');

    var deskOuter = document.getElementById('ldrev-desk');
    var mobOuter  = document.getElementById('ldrev-mob');

    bindVideoCards(deskOuter, '.ldrev-d-video-card');
    bindVideoCards(mobOuter,  '.ldrev-m-video-card');

    setupLoadMore('ldrev-d-load-btn', 'ldrev-d-hide-btn', 'ldrev-d-extra', 'ldrev-d-hidden', 'ldrev-visible', true);
    setupLoadMore('ldrev-m-load-btn', 'ldrev-m-hide-btn', 'ldrev-m-extra', 'ldrev-m-hidden', 'ldrev-visible', false);

    // Close modal buttons
    document.querySelectorAll('[data-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    // Keyboard close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('ldrev-is-open')) {
        closeModal();
      }
    });

    scaleDesk();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-expert.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;

  function scaleDesk() {
    var outer = document.getElementById('ldex-desk-outer');
    var inner = document.getElementById('ldex-desk');
    if (!outer || !inner) return;

    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';

    var h = inner.offsetHeight;
    var s = window.innerWidth / CANVAS;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  function initPlayers() {
    var videoId    = window.ldexYouTubeId;
    var videoStart = window.ldexYouTubeStart || 485;
    var videoTitle = window.ldexYouTubeTitle || '';

    if (!videoId) return;

    var src = 'https://www.youtube.com/embed/' + videoId
      + '?start=' + videoStart
      + '&autoplay=1&mute=1&rel=0&modestbranding=1&playsinline=1';

    var iframeHTML = '<iframe'
      + ' src="' + src + '"'
      + ' title="' + videoTitle + '"'
      + ' width="100%" height="100%"'
      + ' frameborder="0"'
      + ' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"'
      + ' allowfullscreen'
      + '></iframe>';

    var deskEl = document.getElementById('ldex-player-desk');
    var mobEl  = document.getElementById('ldex-player-mob');

    if (deskEl) deskEl.innerHTML = iframeHTML;
    if (mobEl)  mobEl.innerHTML  = iframeHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scaleDesk();
      initPlayers();
    });
  } else {
    scaleDesk();
    initPlayers();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-derm.js — desktop 3-up carousel + mobile slider
================================================ */
(function () {
  'use strict';

  var CANVAS    = 1440;
  var D_VISIBLE = 3;
  var D_GAP     = 20;
  var D_PADDING = 164;
  var D_SLIDE_W = (CANVAS - D_PADDING - D_GAP * (D_VISIBLE - 1)) / D_VISIBLE;
  var M_GAP     = 12;

  /* ── Desktop scale ─────────────────────────────── */
  function scaleDesk() {
    var outer = document.getElementById('ldderm-desk-outer');
    var inner = document.getElementById('ldderm-desk');
    if (!outer || !inner) return;

    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';

    var h = inner.offsetHeight;
    var s = window.innerWidth / CANVAS;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  /* ── Desktop slider ────────────────────────────── */
  var dCurrent   = 0;
  var dGroups    = 0;
  var dPaused    = false;
  var dAnimating = false;

  function dGetOffset(idx) {
    return idx * (D_SLIDE_W + D_GAP);
  }

  function dSetTransform(idx, animated) {
    var slidesEl = document.getElementById('ldderm-d-slides');
    if (!slidesEl) return;
    slidesEl.style.transition = animated ? 'transform 0.5s ease' : 'none';
    slidesEl.style.transform  = 'translateX(-' + dGetOffset(idx) + 'px)';
  }

  function dUpdateDots() {
    document.querySelectorAll('#ldderm-d-dots button').forEach(function (d, i) {
      var active = i === dCurrent;
      d.className = active ? 'ldderm-d-dot--active' : 'ldderm-d-dot';
      d.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function dGoTo(idx) {
    if (dAnimating) return;
    dAnimating = true;
    dCurrent = idx;
    dSetTransform(dCurrent + D_VISIBLE, true);
    dUpdateDots();
    setTimeout(function () { dAnimating = false; }, 500);
  }

  function dInit() {
    var slidesEl = document.getElementById('ldderm-d-slides');
    if (!slidesEl) return;

    var origSlides = Array.prototype.slice.call(
      slidesEl.querySelectorAll('.ldderm-d-slide')
    );
    dGroups = origSlides.length;
    if (dGroups === 0) return;

    for (var i = 0; i < D_VISIBLE; i++) {
      var cloneStart = origSlides[i].cloneNode(true);
      cloneStart.setAttribute('aria-hidden', 'true');
      slidesEl.appendChild(cloneStart);
    }
    for (var j = dGroups - 1; j >= dGroups - D_VISIBLE; j--) {
      var cloneEnd = origSlides[j].cloneNode(true);
      cloneEnd.setAttribute('aria-hidden', 'true');
      slidesEl.insertBefore(cloneEnd, slidesEl.firstChild);
    }

    dCurrent = 0;
    dSetTransform(dCurrent + D_VISIBLE, false);
    dUpdateDots();

    slidesEl.addEventListener('transitionend', function () {
      var pos = dCurrent + D_VISIBLE;
      if (pos >= dGroups + D_VISIBLE) {
        dCurrent = 0;
        dSetTransform(dCurrent + D_VISIBLE, false);
      } else if (pos < D_VISIBLE) {
        dCurrent = dGroups - 1;
        dSetTransform(dCurrent + D_VISIBLE, false);
      }
    });

    setInterval(function () {
      if (!dPaused) dGoTo(dCurrent + 1);
    }, 4000);

    slidesEl.addEventListener('mouseenter', function () { dPaused = true; });
    slidesEl.addEventListener('mouseleave', function () { dPaused = false; });

    var prevBtn = document.getElementById('ldderm-d-prev');
    var nextBtn = document.getElementById('ldderm-d-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { dGoTo(dCurrent - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { dGoTo(dCurrent + 1); });

    document.querySelectorAll('#ldderm-d-dots button').forEach(function (d) {
      d.addEventListener('click', function () {
        dGoTo(parseInt(d.getAttribute('data-index'), 10));
      });
    });
  }

  /* ── Mobile slider ─────────────────────────────── */
  var mCurrent   = 0;
  var mTotal     = 0;
  var mPaused    = false;
  var mAnimating = false;

  function mGetSlideW() {
    var slide = document.querySelector(
      '#ldderm-m-slides .ldderm-m-slide:not([aria-hidden])'
    );
    return slide ? slide.offsetWidth : 343;
  }

  function mSetTransform(idx, animated) {
    var slidesEl = document.getElementById('ldderm-m-slides');
    if (!slidesEl) return;
    var offset = idx * (mGetSlideW() + M_GAP);
    slidesEl.style.transition = animated ? 'transform 0.5s ease' : 'none';
    slidesEl.style.transform  = 'translateX(-' + offset + 'px)';
  }

  function mUpdateDots() {
    document.querySelectorAll('#ldderm-m-dots .ldderm-m-dot').forEach(function (d, i) {
      var active = i === mCurrent;
      d.classList.toggle('ldderm-m-dot--active', active);
      d.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function mGoTo(idx) {
    if (mAnimating) return;
    mAnimating = true;
    mCurrent = idx;
    mSetTransform(mCurrent + 1, true);
    mUpdateDots();
    setTimeout(function () { mAnimating = false; }, 500);
  }

  function mInit() {
    var slidesEl = document.getElementById('ldderm-m-slides');
    if (!slidesEl) return;

    var origSlides = Array.prototype.slice.call(
      slidesEl.querySelectorAll('.ldderm-m-slide')
    );
    mTotal = origSlides.length;
    if (mTotal === 0) return;

    var cloneFirst = origSlides[0].cloneNode(true);
    cloneFirst.setAttribute('aria-hidden', 'true');
    slidesEl.appendChild(cloneFirst);

    var cloneLast = origSlides[mTotal - 1].cloneNode(true);
    cloneLast.setAttribute('aria-hidden', 'true');
    slidesEl.insertBefore(cloneLast, slidesEl.firstChild);

    mCurrent = 0;
    mSetTransform(mCurrent + 1, false);
    mUpdateDots();

    slidesEl.addEventListener('transitionend', function () {
      var pos = mCurrent + 1;
      if (pos >= mTotal + 1) {
        mCurrent = 0;
        mSetTransform(mCurrent + 1, false);
      } else if (pos < 1) {
        mCurrent = mTotal - 1;
        mSetTransform(mCurrent + 1, false);
      }
    });

    /* ── Touch swipe ─────────────────────────────── */
    var touchStartX = 0;
    var touchDeltaX = 0;
    var swipeThreshold = 50;

    slidesEl.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
      mPaused = true;
    }, { passive: true });

    slidesEl.addEventListener('touchmove', function (e) {
      touchDeltaX = e.touches[0].clientX - touchStartX;
    }, { passive: true });

    slidesEl.addEventListener('touchend', function () {
      if (touchDeltaX < -swipeThreshold) {
        mGoTo(mCurrent + 1);
      } else if (touchDeltaX > swipeThreshold) {
        mGoTo(mCurrent - 1);
      }
      setTimeout(function () { mPaused = false; }, 1000);
    }, { passive: true });

    /* Auto-play */
    setInterval(function () {
      if (!mPaused) mGoTo(mCurrent + 1);
    }, 4000);

    document.querySelectorAll('#ldderm-m-dots .ldderm-m-dot').forEach(function (d) {
      d.addEventListener('click', function () {
        mGoTo(parseInt(d.getAttribute('data-index'), 10));
      });
    });
  }

  /* ── Init ──────────────────────────────────────── */
  function init() {
    scaleDesk();
    dInit();
    mInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      scaleDesk();
      dSetTransform(dCurrent + D_VISIBLE, false);
      mSetTransform(mCurrent + 1, false);
    }, 50);
  });

})();


/* ================================================
   ld-faq.js — desktop scaling + accordion rescale
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;

  function scaleDesk() {
    var outer = document.getElementById('ldfaq-desk-outer');
    var inner = document.getElementById('ldfaq-desk');
    if (!outer || !inner) return;

    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';

    var h = inner.offsetHeight;
    var s = window.innerWidth / CANVAS;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  function init() {
    scaleDesk();

    /* Rescale after accordion toggle (height changes) */
    var items = document.querySelectorAll('.ldfaq-d-faq-item, .ldfaq-m-faq-item');
    items.forEach(function (det) {
      det.addEventListener('toggle', function () {
        setTimeout(scaleDesk, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-footer.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;

  function scaleDesk() {
    var outer = document.getElementById('ldf-desk-outer');
    var inner = document.getElementById('ldf-desk');
    if (!outer || !inner) return;

    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';

    var h = inner.offsetHeight;
    var s = window.innerWidth / CANVAS;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-sticky.js — sticky bar + sync from tvproof
================================================ */
(function () {
  'use strict';

  var bar = document.getElementById('ldsticky-bar');
  if (!bar) return;

  bar.style.transform = 'translateY(100%)';
  bar.style.transition = 'transform 0.35s ease';

  function showBar() { bar.style.transform = 'translateY(0)'; }
  function hideBar() { bar.style.transform = 'translateY(100%)'; }

  /* offerCard — used to observe when to show/hide the bar
     tvproof   — used for form data, handle, clicks */
  var offerCard = document.querySelector('.ld-tvproof__offer-card');
  var tvproof   = document.querySelector('.ld-tvproof');

  if (!offerCard || !tvproof) return;

  /* Show bar when offer-card is fully scrolled past */
  window.addEventListener('scroll', function () {
    var rect = offerCard.getBoundingClientRect();
    if (rect.bottom < 0) {
      showBar();
    } else {
      hideBar();
    }
  }, { passive: true });

  /* ================================================
     Sync price / image / variant from tvproof
  ================================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var priceEls        = bar.querySelectorAll('.ldsticky-price');
  var priceOldEls     = bar.querySelectorAll('.ldsticky-price-old');
  var imgEls          = bar.querySelectorAll('.ldsticky-variant-img');
  var variantTitleEls = bar.querySelectorAll('.ldsticky-variant-title');

  function syncFromTvproof() {
    var form         = tvproof.querySelector('.ld-tvproof__form');
    var variantInput = form ? form.querySelector('.ld-variant-id') : null;
    var planInput    = form ? form.querySelector('.ld-selling-plan') : null;

    if (!variantInput || !variantInput.value) return;

    var handle = tvproof.getAttribute('data-product-handle');
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variantId = variantInput.value;
        var variant   = product.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (!variant) return;

        var isSubscription = planInput && !planInput.disabled && planInput.value;
        var alloc = isSubscription
          ? (variant.selling_plan_allocations || [])[0] || null
          : null;

        var price    = alloc ? alloc.per_delivery_price : variant.price;
        var priceOld = alloc
          ? (alloc.compare_at_price > alloc.price ? alloc.compare_at_price : null)
          : (variant.compare_at_price > variant.price ? variant.compare_at_price : null);

        priceEls.forEach(function (el) { el.textContent = formatMoney(price); });
        priceOldEls.forEach(function (el) {
          el.textContent = priceOld ? formatMoney(priceOld) : '';
          el.style.display = priceOld ? '' : 'none';
        });

        var imgSrc = variant.featured_image
          ? variant.featured_image.src
          : (product.featured_image || null);
        if (imgSrc) { imgEls.forEach(function (el) { el.src = imgSrc; }); }

        variantTitleEls.forEach(function (el) { el.textContent = variant.title || ''; });
      })
      .catch(function (err) { console.error('[ld-sticky] sync error:', err); });
  }

  function watchTvproof() {
    var form = tvproof.querySelector('.ld-tvproof__form');
    if (!form) { setTimeout(watchTvproof, 200); return; }

    var variantInput = form.querySelector('.ld-variant-id');
    if (!variantInput) { setTimeout(watchTvproof, 200); return; }

    syncFromTvproof();

    var mo = new MutationObserver(function () { syncFromTvproof(); });
    mo.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    tvproof.addEventListener('click', function (e) {
      if (e.target.closest('.ld-tvproof__bundle-btn') || e.target.closest('.ld-tvproof__purchase-option')) {
        setTimeout(syncFromTvproof, 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchTvproof);
  } else {
    watchTvproof();
  }

  /* ================================================
     Checkout
  ================================================ */
  function handleCheckout(e) {
    e.preventDefault();

    var form         = tvproof.querySelector('.ld-tvproof__form');
    var variantInput = form ? form.querySelector('.ld-variant-id') : null;
    var planInput    = form ? form.querySelector('.ld-selling-plan') : null;

    if (!variantInput || !variantInput.value) { window.location.href = '/checkout'; return; }

    var btn = e.currentTarget;
    var textEl = btn.querySelector('.ldsticky-m-btn-text, .ldsticky-d-btn-text');
    var originalText = textEl ? textEl.textContent : 'CHECKOUT NOW';
    if (textEl) textEl.textContent = 'Adding...';
    btn.disabled = true;

    var item = { id: parseInt(variantInput.value, 10), quantity: 1 };
    if (planInput && !planInput.disabled && planInput.value) {
      item.selling_plan = parseInt(planInput.value, 10);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) { if (!res.ok) throw new Error('cart/add failed'); return res.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        console.error('[ld-sticky] cart error:', err);
        if (textEl) textEl.textContent = originalText;
        btn.disabled = false;
      });
  }

  bar.querySelectorAll('.ldsticky-btn').forEach(function (btn) {
    btn.addEventListener('click', handleCheckout);
  });

}());


/* ================================================
   ld-cta.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;

  function scaleDesk() {
    var outer = document.getElementById('ldcta-desk-outer');
    var inner = document.getElementById('ldcta-desk');
    if (!outer || !inner) return;

    inner.style.transform       = '';
    inner.style.transformOrigin = '';
    outer.style.height          = '';

    var h = inner.offsetHeight;
    var s = window.innerWidth / CANVAS;

    inner.style.width           = CANVAS + 'px';
    inner.style.transformOrigin = 'top left';
    inner.style.transform       = 'scale(' + s + ')';
    outer.style.height          = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

}());


/* ================================================
   ld-right.js — desktop scaling only
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;

  function scaleDesk() {
    var outer = document.getElementById('ldrgt-desk-outer');
    var inner = document.getElementById('ldrgt-desk');
    if (!outer || !inner) return;

    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';

    var s = window.innerWidth / CANVAS;
    var h = inner.offsetHeight;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleDesk);
  } else {
    scaleDesk();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(scaleDesk, 50);
  });

})();


/* ================================================
   ld-buyers.js — desktop scaling + dividers
================================================ */
(function () {
  'use strict';

  var CANVAS = 1440;

  function scaleDesk() {
    var outer = document.getElementById('ldbuy-desk-outer');
    var inner = document.getElementById('ldbuy-desk');
    if (!outer || !inner) return;

    inner.style.transform = '';
    inner.style.transformOrigin = '';
    outer.style.height = '';

    var s = window.innerWidth / CANVAS;
    var h = inner.offsetHeight;

    inner.style.transformOrigin = 'top left';
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = Math.round(h * s) + 'px';
  }

  function fixDividers() {
    /* Desktop — vertical line */
    var dDivider = document.querySelector('#ldbuy-desk .ldbuy-d-divider-line');
    var dContent = document.querySelector('#ldbuy-desk .ldbuy-d-content');
    if (dDivider && dContent) {
      var dh = dContent.offsetHeight;
      if (dh > 0) {
        dDivider.style.cssText = [
          'width:1px',
          'height:' + dh + 'px',
          'min-height:' + dh + 'px',
          'flex-shrink:0',
          'display:block',
          'background:rgba(209,209,209,0.4)'
        ].join(';');
      }
    }

    /* Mobile — horizontal line */
    var mDivider = document.querySelector('#ldbuy-mob .ldbuy-m-divider-line');
    var mContent = document.querySelector('#ldbuy-mob .ldbuy-m-content');
    if (mDivider && mContent) {
      var mw = mContent.offsetWidth;
      if (mw > 0) {
        mDivider.style.cssText = [
          'width:' + mw + 'px',
          'height:1px',
          'min-width:' + mw + 'px',
          'flex-shrink:0',
          'display:block',
          'background:rgba(209,209,209,0.4)'
        ].join(';');
      }
    }
  }

  function init() {
    scaleDesk();
    fixDividers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      scaleDesk();
      fixDividers();
    }, 50);
  });

})();


/* ================================================
   ld-expert-player.js — YouTube player for expert section
================================================ */
(function () {
  'use strict';

  function initExpertPlayer(holderId) {
    var holder = document.getElementById(holderId);
    if (!holder) return;

    var ytId  = holder.getAttribute('data-youtube-id');
    var start = parseInt(holder.getAttribute('data-start') || '0', 10);
    if (!ytId) return;

    var muted  = true;
    var player = null;

    /* Dimensions from parent */
    var wrap = holder.parentNode;
    var w    = wrap ? wrap.offsetWidth  : 560;
    var h    = wrap ? wrap.offsetHeight : 420;

    player = new YT.Player(holderId, {
      width:   w || 560,
      height:  h || 420,
      videoId: ytId,
      playerVars: {
        playsinline:    1,
        rel:            0,
        modestbranding: 1
      },
      events: {
        onReady: function (evt) {
          /* Muted autoplay from the given start time */
          try {
            evt.target.mute();
            evt.target.seekTo(start, true);
            evt.target.playVideo();
          } catch (e) {}
        },
        onStateChange: function (evt) {
          if (evt.data === YT.PlayerState.ENDED) {
            /* On end — restart muted from start time */
            muted = true;
            try {
              evt.target.mute();
              evt.target.seekTo(start, true);
              evt.target.playVideo();
            } catch (e) {}
          }
        }
      }
    });

    /* Click on iframe wrapper → unmute */
    var iframeWrap = holder.parentNode;
    if (iframeWrap) {
      iframeWrap.addEventListener('click', function () {
        if (muted && player && player.unMute) {
          muted = false;
          try {
            player.unMute();
            player.seekTo(start, true);
            player.playVideo();
          } catch (e) {}
        }
      });
    }
  }

  function init() {
    var dHolder = document.getElementById('ldex-d-player');
    var mHolder = document.getElementById('ldex-m-player');
    if (!dHolder && !mHolder) return;

    /* If YT API already ready (loaded by ld-tvproof.js) */
    if (window.YT && window.YT.Player) {
      if (dHolder) initExpertPlayer('ldex-d-player');
      if (mHolder) initExpertPlayer('ldex-m-player');
      return;
    }

    /* Wait for API — preserve previous callback to avoid conflicts */
    var prevReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prevReady === 'function') prevReady();
      if (dHolder) initExpertPlayer('ldex-d-player');
      if (mHolder) initExpertPlayer('ldex-m-player');
    };

    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());